import { Row, Col } from "antd";
import { Footer } from "antd/lib/layout/layout";
import React from "react";
import eu_logo from "../../../core/ui/assets/images/eu-emblem.jpg";
import aire_logo from "../../../core/ui/assets/images/aire-logo2.png";
import gb_logo from "../../../core/ui/assets/images/gb-logo.png";
import { TTranslate } from "../../../core/service/locale/TranslationService";

export default function LayoutFooter({ translate }: { translate: TTranslate }) {
  return (
    <Footer className="dashboard-footer">
      <div className="dashboard-footer-subfooter"></div>
      <div className="dashboard-footer-content">
        <Row gutter={[24, 12]}>
          <Col
            xs={24}
            sm={24}
            md={8}
            className="align-center align-md-right"
          ></Col>
          <Col xs={24} sm={24} md={8} className="align-center "></Col>
          <Col
            xs={24}
            sm={24}
            md={8}
            className="align-center align-md-left"
            style={{ alignItems: "center" }}
          ></Col>
          <Col xs={24} sm={24} className="align-center ">
            <h6>{translate("app.eu_disclaimer")}</h6>
          </Col>
        </Row>
      </div>
    </Footer>
  );
}
